// extracted by mini-css-extract-plugin
export var title = "examples-item-module--title--hbT5s";
export var description = "examples-item-module--description--XRMuD";
export var imgWrapper = "examples-item-module--img-wrapper--Scitw";
export var item = "examples-item-module--item--R74Ff";